import { ContactUs } from "components/emai";
import React from "react";

const Contact = () => {
  return (
    <div className="new-tab-content-container">
      <div>
        <h1>Contact Me</h1>
        <ContactUs />
      </div>
    </div>
  );
};

export default Contact;
